import { Maybe } from './globalTypes'

import {
  ImageDiffFragment,
  isImageDiffFragment,
} from './ImageDiffFragment'

import contentPopFragmentRawString from '../../fragments/ContentPopFragment.graphql'

export const contentPopFragmentString = contentPopFragmentRawString

export type ContentPopFragment = {
  __typename: 'ComponentExpandContentPop'
  id: string
  bannerImages: Maybe<{
    url: string
    alternativeText: Maybe<string>
  }>[]
  contentStream: Maybe<
    Maybe<{
      id: string
      title: Maybe<string>
      description: Maybe<string>
    }>[]
  >
  imageDiff: Maybe<ImageDiffFragment>
}

export const isContentPopFragment = (
  fragment: any,
): fragment is ContentPopFragment =>
  fragment &&
  fragment.__typename === 'ComponentExpandContentPop' &&
  typeof fragment.id === 'string' &&
  Array.isArray(fragment.bannerImages) &&
  fragment.bannerImages
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum &&
        (next === null ||
          (next &&
            typeof next.url === 'string' &&
            (next.alternativeText === null ||
              typeof next.alternativeText === 'string'))),
      true,
    ) &&
  (fragment.contentStream === null ||
    (Array.isArray(fragment.contentStream) &&
      fragment.contentStream
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum &&
            (next === null ||
              (next &&
                typeof next.id === 'string' &&
                (next.title === null || typeof next.title === 'string') &&
                (next.description === null ||
                  typeof next.description === 'string'))),
          true,
        ))) &&
  (fragment.imageDiff === null ||
    (isImageDiffFragment(fragment.imageDiff) as boolean))
